import { CountryCodes } from '@/enums/general'
import {
  MenPrices as newMenPrices,
  BoysPrices as newBoysPrices,
  SocksDiscountPrices as newSocksDiscountPrices,
  UndershirtsDiscountPrices as newUndershirtsDiscountPrices
} from '@/enums/prices'

// Orientations / Slugs
export const Orientations = Object.freeze({
  menoriginals: 'men-originals',
  menone: 'men-one',
  boysoriginals: 'boys-originals',
  socksoriginals: 'originals-socks-regular',
  sneakersocksoriginals: 'originals-socks-sneaker',
  womenbralette: 'women-bralette',
  womenhipster: 'women-hipster',
  undershirts: 'men-undershirt'
})

// Orientations / Slugs
export const NewOrientations = Object.freeze({
  men: 'men',
  boys: 'boys',
  women: 'women',
  addon: 'addon'
})

// Orientations by Group Id's
export const OrientationsByGroupIds = Object.freeze({
  1: Orientations.menoriginals,
  2: Orientations.menone,
  3: Orientations.boysoriginals,
  21: Orientations.socksoriginals
})

// Orientations by Group Id's
export const OrientationSlugsByGroupIds = Object.freeze({
  1: Orientations.menoriginals,
  2: Orientations.menone,
  3: Orientations.boysoriginals,
  21: Orientations.socksoriginals
})

// Orientations first release dates
export const OrientationsStartDates = Object.freeze({
  1: '15-04-2015',
  2: '01-01-2019',
  3: '15-4-2018',
  21: '1-9-2021'
})

// Orientation names by Group Id's
export const OrientationsNamesByGroupIds = Object.freeze({
  1: 'Men Originals',
  2: 'Men One',
  3: 'Boys Originals',
  21: 'Socks'
})

// Group Id's by orientation names
export const GroupIdsByName = Object.freeze({
  [Orientations.menoriginals]: Object.keys(OrientationsByGroupIds)[0],
  [Orientations.menone]: Object.keys(OrientationsByGroupIds)[1],
  [Orientations.boysoriginals]: Object.keys(OrientationsByGroupIds)[2],
  [Orientations.socksoriginals]: Object.keys(OrientationsByGroupIds)[3],
  socks: Object.keys(OrientationsByGroupIds)[3]
})

// TODO: move to backend
// Men Originals and Men One Subscription Prices
export const MenPrices = Object.freeze({
  [CountryCodes.austria]: newMenPrices[CountryCodes.austria],
  [CountryCodes.belgium]: newMenPrices[CountryCodes.belgium],
  [CountryCodes.denmark]: newMenPrices[CountryCodes.denmark],
  [CountryCodes.germany]: newMenPrices[CountryCodes.germany],
  [CountryCodes.spain]: newMenPrices[CountryCodes.spain],
  [CountryCodes.france]: newMenPrices[CountryCodes.france],
  [CountryCodes.netherlands]: newMenPrices[CountryCodes.netherlands],
  [CountryCodes.unitedKingdom]: newMenPrices[CountryCodes.unitedKingdom],
  [CountryCodes.sweden]: newMenPrices[CountryCodes.sweden],
  [CountryCodes.italy]: newMenPrices[CountryCodes.italy],
  [CountryCodes.poland]: newMenPrices[CountryCodes.poland],
  [CountryCodes.switzerland]: newMenPrices[CountryCodes.switzerland],
  [CountryCodes.ireland]: newMenPrices[CountryCodes.ireland],
  [CountryCodes.luxembourg]: newMenPrices[CountryCodes.luxembourg],
  [CountryCodes.portugal]: newMenPrices[CountryCodes.portugal],
  [CountryCodes.finland]: newMenPrices[CountryCodes.finland],
  [CountryCodes.norway]: newMenPrices[CountryCodes.norway],
  [CountryCodes.czechRepublic]: newMenPrices[CountryCodes.czechRepublic]
})

export const WomenPrices = Object.freeze({
  [CountryCodes.austria]: 12.99,
  [CountryCodes.belgium]: 12.99,
  [CountryCodes.denmark]: 110,
  [CountryCodes.germany]: 12.99,
  [CountryCodes.spain]: 12.99,
  [CountryCodes.france]: 12.99,
  [CountryCodes.netherlands]: 12.99,
  [CountryCodes.unitedKingdom]: 12.99,
  [CountryCodes.sweden]: 151,
  [CountryCodes.italy]: 12.99,
  [CountryCodes.poland]: 57,
  [CountryCodes.switzerland]: 12.99,
  [CountryCodes.ireland]: 12.99,
  [CountryCodes.luxembourg]: 12.99,
  [CountryCodes.portugal]: 12.99,
  [CountryCodes.finland]: 12.99,
  [CountryCodes.norway]: 153,
  [CountryCodes.czechRepublic]: 329
})

// Boys Originals Subscription Prices
export const BoysPrices = Object.freeze({
  [CountryCodes.austria]: newBoysPrices[CountryCodes.austria],
  [CountryCodes.belgium]: newBoysPrices[CountryCodes.belgium],
  [CountryCodes.denmark]: newBoysPrices[CountryCodes.denmark],
  [CountryCodes.germany]: newBoysPrices[CountryCodes.germany],
  [CountryCodes.spain]: newBoysPrices[CountryCodes.spain],
  [CountryCodes.france]: newBoysPrices[CountryCodes.france],
  [CountryCodes.netherlands]: newBoysPrices[CountryCodes.netherlands],
  [CountryCodes.unitedKingdom]: newBoysPrices[CountryCodes.unitedKingdom],
  [CountryCodes.sweden]: newBoysPrices[CountryCodes.sweden],
  [CountryCodes.italy]: newBoysPrices[CountryCodes.italy],
  [CountryCodes.poland]: newBoysPrices[CountryCodes.poland],
  [CountryCodes.switzerland]: newBoysPrices[CountryCodes.switzerland],
  [CountryCodes.ireland]: newBoysPrices[CountryCodes.ireland],
  [CountryCodes.luxembourg]: newBoysPrices[CountryCodes.luxembourg],
  [CountryCodes.portugal]: newBoysPrices[CountryCodes.portugal],
  [CountryCodes.finland]: newBoysPrices[CountryCodes.finland],
  [CountryCodes.norway]: newBoysPrices[CountryCodes.norway],
  [CountryCodes.czechRepublic]: newBoysPrices[CountryCodes.czechRepublic]
})

// Socks Originals Subscription Prices
export const SocksPrices = Object.freeze({
  [CountryCodes.austria]: 8.99,
  [CountryCodes.belgium]: 8.99,
  [CountryCodes.denmark]: 67,
  [CountryCodes.germany]: 8.99,
  [CountryCodes.spain]: 8.99,
  [CountryCodes.france]: 8.99,
  [CountryCodes.netherlands]: 8.99,
  [CountryCodes.unitedKingdom]: 8.99,
  [CountryCodes.sweden]: 93,
  [CountryCodes.italy]: 8.99,
  [CountryCodes.poland]: 44,
  [CountryCodes.switzerland]: 9.95,
  [CountryCodes.ireland]: 9.99,
  [CountryCodes.luxembourg]: 9.99,
  [CountryCodes.portugal]: 8.99,
  [CountryCodes.finland]: 9.99,
  [CountryCodes.norway]: 119,
  [CountryCodes.czechRepublic]: 212
})

// Socks Originals Subscription Prices With Active Boxers Membership
export const SocksDiscountPrices = Object.freeze({
  [CountryCodes.austria]: newSocksDiscountPrices[CountryCodes.austria],
  [CountryCodes.belgium]: newSocksDiscountPrices[CountryCodes.belgium],
  [CountryCodes.denmark]: newSocksDiscountPrices[CountryCodes.denmark],
  [CountryCodes.germany]: newSocksDiscountPrices[CountryCodes.germany],
  [CountryCodes.spain]: newSocksDiscountPrices[CountryCodes.spain],
  [CountryCodes.france]: newSocksDiscountPrices[CountryCodes.france],
  [CountryCodes.netherlands]: newSocksDiscountPrices[CountryCodes.netherlands],
  [CountryCodes.unitedKingdom]: newSocksDiscountPrices[CountryCodes.unitedKingdom],
  [CountryCodes.sweden]: newSocksDiscountPrices[CountryCodes.sweden],
  [CountryCodes.italy]: newSocksDiscountPrices[CountryCodes.italy],
  [CountryCodes.poland]: newSocksDiscountPrices[CountryCodes.poland],
  [CountryCodes.switzerland]: newSocksDiscountPrices[CountryCodes.switzerland],
  [CountryCodes.ireland]: newSocksDiscountPrices[CountryCodes.ireland],
  [CountryCodes.luxembourg]: newSocksDiscountPrices[CountryCodes.luxembourg],
  [CountryCodes.portugal]: newSocksDiscountPrices[CountryCodes.portugal],
  [CountryCodes.finland]: newSocksDiscountPrices[CountryCodes.finland],
  [CountryCodes.norway]: newSocksDiscountPrices[CountryCodes.norway],
  [CountryCodes.czechRepublic]: newSocksDiscountPrices[CountryCodes.czechRepublic]
})

export const UndershirtsPrices = Object.freeze({
  [CountryCodes.austria]: 12.99,
  [CountryCodes.belgium]: 12.99,
  [CountryCodes.denmark]: 97,
  [CountryCodes.germany]: 12.99,
  [CountryCodes.spain]: 12.99,
  [CountryCodes.france]: 12.99,
  [CountryCodes.netherlands]: 12.99,
  [CountryCodes.unitedKingdom]: 12.99,
  [CountryCodes.sweden]: 149,
  [CountryCodes.italy]: 12.99,
  [CountryCodes.poland]: 55,
  [CountryCodes.switzerland]: 12.99,
  [CountryCodes.ireland]: 12.99,
  [CountryCodes.luxembourg]: 12.99,
  [CountryCodes.portugal]: 12.99,
  [CountryCodes.finland]: 12.99,
  [CountryCodes.norway]: 155,
  [CountryCodes.czechRepublic]: 325
})

export const UndershirtsDiscountPrices = Object.freeze({
  [CountryCodes.austria]: newUndershirtsDiscountPrices[CountryCodes.austria],
  [CountryCodes.belgium]: newUndershirtsDiscountPrices[CountryCodes.belgium],
  [CountryCodes.denmark]: newUndershirtsDiscountPrices[CountryCodes.denmark],
  [CountryCodes.germany]: newUndershirtsDiscountPrices[CountryCodes.germany],
  [CountryCodes.spain]: newUndershirtsDiscountPrices[CountryCodes.spain],
  [CountryCodes.france]: newUndershirtsDiscountPrices[CountryCodes.france],
  [CountryCodes.netherlands]: newUndershirtsDiscountPrices[CountryCodes.netherlands],
  [CountryCodes.unitedKingdom]: newUndershirtsDiscountPrices[CountryCodes.unitedKingdom],
  [CountryCodes.sweden]: newUndershirtsDiscountPrices[CountryCodes.sweden],
  [CountryCodes.italy]: newUndershirtsDiscountPrices[CountryCodes.italy],
  [CountryCodes.poland]: newUndershirtsDiscountPrices[CountryCodes.poland],
  [CountryCodes.switzerland]: newUndershirtsDiscountPrices[CountryCodes.switzerland],
  [CountryCodes.ireland]: newUndershirtsDiscountPrices[CountryCodes.ireland],
  [CountryCodes.luxembourg]: newUndershirtsDiscountPrices[CountryCodes.luxembourg],
  [CountryCodes.portugal]: newUndershirtsDiscountPrices[CountryCodes.portugal],
  [CountryCodes.finland]: newUndershirtsDiscountPrices[CountryCodes.finland],
  [CountryCodes.norway]: newUndershirtsDiscountPrices[CountryCodes.norway],
  [CountryCodes.czechRepublic]: newUndershirtsDiscountPrices[CountryCodes.czechRepublic]
})

// Product Types
export const ProductTypes = Object.freeze({
  boxers: 'boxers',
  socks: 'socks'
})

// Product category Ids
export const ProductCategoryIds = Object.freeze({
  // todo:: remove
  [ProductTypes.boxers]: 1,
  [ProductTypes.socks]: 2
})

// Product Types by Id's
export const ProductTypesByIds = Object.freeze({
  [ProductCategoryIds[ProductTypes.boxers]]: ProductTypes.boxers,
  [ProductCategoryIds[ProductTypes.socks]]: ProductTypes.socks
})

export const mensSizes = [
  { value: 1, label: 'XS' },
  { value: 2, label: 'S' },
  { value: 3, label: 'M' },
  { value: 4, label: 'L' },
  { value: 5, label: 'XL' },
  { value: 6, label: 'XXL' },
  { value: 12, label: '3XL' }
]

export const boysSizes = [
  { value: 7, label: '104' },
  { value: 8, label: '110-116' },
  { value: 9, label: '122-128' },
  { value: 10, label: '134-140' },
  { value: 11, label: '146-152' }
]

// Sizes
export const Sizes = Object.freeze({
  mens: mensSizes,
  boys: boysSizes,
  all: [...mensSizes, ...boysSizes]
})

export const ProductGroupSizeIds = Object.freeze({
  [Orientations.womenbralette]: 152,
  [Orientations.womenhipster]: 156
})
